$(function() {
    $('.js-delete-user').on('click', function(){
        var user = $(this).data('username');
        var link = $(this).data('link');

        $('span.js-username').text(user);
        $('a.js-link').attr('href', link);
    });
});
